import Logger, {LOG_LEVELS} from '../logger';
import _ from 'underscore';
const log = new Logger('JSON_TRANSFORMERS', LOG_LEVELS.DEBUG);


function arrayToFlatReference(data){
  const dataType = augmentedTypeof(data);
  let result = '';

  switch (dataType) {
    case 'array':
      data.map((item,index) => {
        if(_.isString(item)){
          if(index != 0) { result += '.'};
          result += item;
        } else {
          result += '[' + item + ']';
        }
      });
      return result;
    default:
      log.debug('arrayToFlatReference: Unhandled data type: ', dataType);
      return data;
  }
}

function augmentedTypeof(value) {
  if (Array.isArray(value)) return 'array';
  if (value === null) return 'null';
  return typeof value;
}

function restructureWithTemplate(template, original, options = { preserveExtraKeys: false }) {
  const templateType = augmentedTypeof(template);
  const originalType = augmentedTypeof(original);

  // Special case: if original is array and template is an object, apply template to each item
  if (originalType === 'array' && templateType === 'object') {
    return original.map(item => restructureWithTemplate(template, item, options));
  }

  switch (templateType) {
    case 'object':
      const resultObj = options.preserveExtraKeys && originalType === 'object' ? { ...original } : {};

      for (const key of Object.keys(template)) {
        if (key === '_' && originalType === 'string') {
          resultObj[key] = original;
        } else {
          const originalValue = originalType === 'object' ? original[key] : undefined;
          resultObj[key] = restructureWithTemplate(template[key], originalValue, options);
        }
      }

      return resultObj;
    case 'array':
      if (originalType === 'undefined' || original === null) return [];

      // Normalize to array
      const normalizedArray = Array.isArray(original) ? original : [original];

      return normalizedArray.map(item =>
        restructureWithTemplate(template[0], item, options)
      );
    case 'undefined':
      return original;
    default:
      return originalType === templateType ? original : template;
  }
}

function objectMapToFlatReference(data, fieldName) {
  const originalType = augmentedTypeof(data);

  switch (originalType) {
    case 'object':
      return Object.keys(data).reduce((result, key) => {
        result[key] = objectMapToFlatReference(data[key], fieldName ? fieldName + '.' + key : key);
        return result;
      },{});
    case 'array':
      if (originalType !== 'array') return [];            // How could this line be as the switch confirms it is array?
      return data.map((item, index) => {
        return objectMapToFlatReference(item, fieldName ? fieldName + '[' + index + ']' : '[' + index + ']');
      });
    default:
      return fieldName;
  }
}

function flattenJSON(structured)  {
  let flat = {};
  function recurse (current, property) {
    if (Object(current) !== current) {
      flat[property] = current;
    } else if (Array.isArray(current)) {
      for(var i=0, currentLength=current.length; i<currentLength; i++)
        recurse(current[i], property + "[" + i + "]");
      if (currentLength == 0)
        flat[property] = [];
    } else {
      var isEmpty = true;
      for (var p in current) {
        isEmpty = false;
        recurse(current[p], property ? property + "." + p : p);
      }
      if (isEmpty)
        flat[property] = {};
    }
  }
  recurse(structured, "");
  return flat;
}

function  unflattenJSON(flat)  {
  "use strict";
  if (Object(flat) !== flat || Array.isArray(flat))
    return flat;
  const regex = /\.?([^.\[\]]+)|\[(\d+)\]/g;
  let structured = {};
  for (let p in flat) {
    let current = structured;
    let property = "";
    let m;
    while (m = regex.exec(p)) {
      current = current[property] || (current[property] = (m[2] ? [] : {}));
      property = m[2] || m[1];
    }
    current[property] = flat[p];
  }
  return structured[""] || structured;
}


export default {

  arrayToFlatReference(data)
  {
    log.debug('arrayToFlatReference: ', data);
    return arrayToFlatReference(data);
  },

  unflattenJSON(flat){
    log.debug('jsonTransformers: unflattenJSON: ', flat);
    return unflattenJSON(flat);
  },

  flattenJSON(structured){
    log.debug('jsonTransformers: flattenJSON: ', structured);
    return flattenJSON(structured);
  },

  doRestructureWithTemplate(template, original) {
    log.debug('doRestructureWithTemplate: Template: %j', template);
    return restructureWithTemplate(template, original);
  },

  doObjectMapToFlatReference(structured, prefix){
    log.debug('doObjectMapToFlatReference: ', structured );
    return objectMapToFlatReference(structured, prefix);
  }

}
